var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-marginless is-multiline"},[(!_vm.isResellerClient)?_c('div',{staticClass:"column is-12"},[_c('general-enquiry-cta')],1):_vm._e(),_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"box"},[_c('tasks-table',{attrs:{"participant-id":_vm.userId,"is-open":false}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }